import { render, staticRenderFns } from "./RealWorldCaseloads.vue?vue&type=template&id=78691d36&scoped=true"
import script from "./RealWorldCaseloads.vue?vue&type=script&lang=js"
export * from "./RealWorldCaseloads.vue?vue&type=script&lang=js"
import style0 from "./RealWorldCaseloads.vue?vue&type=style&index=0&id=78691d36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78691d36",
  null
  
)

export default component.exports